export const messages = {
  en: {
    productStock: {
      title: 'Stock Information',
      searchTitle: 'Search Stock',
      inputTitle: 'Stock In Information',
      productName: 'Product Name',
      barcode: 'Barcode',
      stockInTime: 'Stock In Time',
      status: 'Status',
      operator: 'Operator',
      actions: 'Actions',
      deleteConfirm: 'Confirm to delete product information?',
      deleteSuccess: 'Delete successfully',
      stockInSuccess: 'Stock in successfully',
      barcodeRequired: 'Barcode is required',
      back: 'Back',
      search: 'Search',
      stockIn: 'Stock In',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      normal: 'Normal',
      occupied: 'Occupied'
    }
  },
  zh: {
    productStock: {
      title: '库存信息',
      searchTitle: '查询库存',
      inputTitle: '入库信息',
      productName: '商品名称',
      barcode: '条形码',
      stockInTime: '入库时间',
      status: '状态',
      operator: '操作人',
      actions: '操作',
      deleteConfirm: '确定删除商品信息?',
      deleteSuccess: '删除成功',
      stockInSuccess: '入库成功',
      barcodeRequired: '条形码不能为空',
      back: '返回',
      search: '查询',
      stockIn: '入库',
      cancel: '点错了',
      confirmDelete: '确认删除',
      normal: '正常',
      occupied: '占用'
    }
  }
}